<template>
  <div class="py-1">
    <slot />
  </div>
</template>

<script setup></script>
